<template>
  <div class="flex flex-row gap-1.5 items-center">
    <div class="flex flex-row gap-0.5">
      <Button
        :icon="true"
        :disabled="page === 1"
        size="xs"
        variant="tertiary"
        type="gray"
        @click="goToPage(1)"
      >
        <Icon name="expand-left-stop" size="sm" />
      </Button>
      <Button
        :icon="true"
        :disabled="page === 1"
        size="xs"
        variant="tertiary"
        type="gray"
        @click="goToPage(page - 1)"
      >
        <Icon name="chevron-left" size="sm" />
      </Button>
    </div>

    <div class="w-16">
      <TextInput
        class="[&_input]:text-center [&_input]:truncate"
        size="sm"
        v-model="pageInputValue"
        @change="handleUpdatePageInternal"
      />
    </div>

    <span class="text-style-xs font-medium">
      {{ $t("pagination.of") }} {{ totalPages }}
    </span>

    <div class="flex flex-row gap-0.5">
      <Button
        :icon="true"
        :disabled="page === totalPages"
        size="xs"
        variant="tertiary"
        type="gray"
        @click="goToPage(page + 1)"
      >
        <Icon name="chevron-right" size="sm" />
      </Button>
      <Button
        :icon="true"
        :disabled="page === totalPages"
        size="xs"
        variant="tertiary"
        type="gray"
        @click="goToPage(totalPages)"
      >
        <Icon name="expand-right-stop" size="sm" />
      </Button>
    </div>
  </div>
</template>

<script setup>
// Vue utilities
import { ref, watchEffect } from "vue";

// Custom components
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { TextInput } from "@/SharedComponents/Inputs";

// Define Props
const props = defineProps({
  page: Number,
  totalPages: Number,
});

// Define Emits
const emit = defineEmits(["update:page"]);

// Refs
const pageInputValue = ref(props.page);

// Functions
const goToPage = (newPage) => {
  const page = Math.max(1, Math.min(newPage, props.totalPages));
  pageInputValue.value = page;
  emit("update:page", page);
};

const handleUpdatePageInternal = () => {
  const newPage = parseInt(pageInputValue.value);
  if (isNaN(newPage)) {
    pageInputValue.value = props.page;
    return;
  }
  goToPage(newPage);
};

// Watchers
watchEffect(() => {
  pageInputValue.value = props.page;
});
</script>
